import { Link } from 'react-router-dom';

const DashboardUnauthorized = () => {
  return (
    <section>
      <h1>You don't have access to this view</h1>
      <Link to="/">
        <h2>Go to home page</h2>
      </Link>
    </section>
  );
};

export default DashboardUnauthorized;
